module.exports = __webpack_public_path__ + "img/L_6C.c7688429.png";